import React from 'react';
import {Card, Row, Col, Button} from 'antd';
import {$$} from './$';

@autobind
export default class Laboratory extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};

  }

  componentDidMount() {
    $$('myDiv').slideLeft().changeHeight();
  }
  _slideUp(){
    console.log('_slideUp');
  }
  _slideDown(){
    console.log('_slideDown');

  }
  render() {

    return (
      <Row

        style={{
          height: '100%',
          overflow: 'auto',
          margin: '0',
        }}>
        <Col sm={24}
             style={{
               height: '100%',
             }}
        >
          <Card
            title="Test"
            style={{
              height: '100%',
              position: 'relative',
            }}
          >
            <div id="myDiv">Amir Hossein</div>
            <Button onClick={this._slideDown} >slideDown</Button>
            <Button onClick={this._slideUp} >slideUp</Button>
          </Card>
        </Col>
      </Row>
    );
  }
}
